import React from "react";
import NoImage from "./NoImage";
import DOMPurify from "dompurify";
import "../Schedule/Schedule.css";

const Elements = ({ id, image_path, location, address, title, artist, contents, date, open_time, door_price, start_time, adv_price, drink_price, etc }) => {

     const createSafeHTML = (html) => {
        return { __html: DOMPurify.sanitize(html) };
    };

    // const BASE_URL = "http://localhost:8000";
    const BASE_URL = "https://aoyamania.jp";


    return (
        <div className="schedule-contents-wrapper" id={id}>

            <div className="schedule-contents-title-wrapper">
                <div className="schedule-contents-title-inner">
                    <div className="schedule-contents-date">
                        {date}
                    </div>
                    <div className="schedule-contents-location">
                        @{location}
                    </div>
                    <div className="schedule-contents-title">
                        【{title}】
                    </div>
                </div>
            </div>
            <div className="schedule-contents-body">
                <div className="schedule-image">
                    {image_path ? <a href={`${BASE_URL}/${image_path}`} target="_blank"><img src={`${BASE_URL}/${image_path}`} alt={date} className='schedule-image-image' /></a> : <NoImage />}
                </div>
                <div className="schedule-contents-contents">
                    日時：{date}<br />
                    会場：{location}<br />
                    {address}<br />
                    <br />
                    Open:{open_time}/Start:{start_time}<br />
                    adv:{adv_price}/door:{door_price}/{drink_price}<br />
                    {etc}<br />
                    <br />
                    出演：{artist}<br />
                    <br />
                    <div dangerouslySetInnerHTML={createSafeHTML(contents)} />
                 


                </div>


            </div>

        </div>

    );
}

export default Elements;